<template>
  <router-view />
</template>

<style lang="scss">
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "../../shared/assets/plugins/line-awesome/css/line-awesome.css";
@import "../../shared/assets/plugins/flaticon/flaticon.css";
@import "../../shared/assets/plugins/flaticon2/flaticon.css";
@import "../../shared/assets/sass/style.vue";
@import "../../shared/assets/sass/global/integration/frameworks/vue/skins";
@import "@/assets/sass/custom/common.scss";

.modal-dialog {
  max-width: 500px !important;
}

.rounded-10 {
  border-radius: 10px;
}

.card-body {
  @media (max-width: 768px) {
    padding: 10px !important;
  }
}

.kt-container {
  @media (max-width: 768px) {
    padding: 5px !important;
  }
}

.__jivoMobileButton {
  z-index: 2147483646 !important;
}
</style>

<script>
export default {
  name: "App",
  mounted() {
    document.addEventListener("dragover", (e) => e.preventDefault());
  },
};
</script>
